import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Currency.css';
import currenciesQuery from './currenciesQuery.graphql';
import CurrencyManagement from '../../../components/siteadmin/CurrencyManagement';
import Loader from '../../../components/Loader';
import { withQuery } from '../../../hoc/withGraphql';

const Currency = (props) => {

  const [state, setState] = useState({ currentPage: 1, searchList: '' });

  const setStateVariable = (variables) => {
    setState(prev => ({
      ...prev,
      ...variables
    }));
  };

  const { data: { loading, getAllCurrencies, refetch }, title } = props;

  if (loading) {
    return <Loader type={"text"} />;
  } else {
    return <CurrencyManagement
      data={getAllCurrencies}
      title={title}
      currentPage={state?.currentPage}
      searchList={state?.searchList}
      refetch={refetch}
      setStateVariable={setStateVariable}
    />
  }
}

Currency.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getCurrencies: PropTypes.array,
  })
};

Currency.defaultProps = {
  data: {
    loading: true
  }
};

export default compose(
  withStyles(s),
  withQuery(currenciesQuery, {
    options: (props) => ({
      variables: {
        currentPage: 1,
        searchList: ''
      },
      fetchPolicy: 'network-only',
      ssr: false
    })
  }),
)(Currency);